import { defineComponent, ref, computed } from "vue";

export default defineComponent({
  name: "c-button",

  props: {
    class: { type: String, default: "btn" },
    textLoading: { type: String, default: "onboardProcessing" },
    isDisabled: { type: Boolean, default: false },
    isLoading: { type: Boolean, default: false },
    type: { type: String, default: "button" },
    value: { type: String, default: "" },
    enum: { type: String, default: "" },
    icon: { type: String, default: "" },
  },

  setup(props, { emit }) {
    const pippleButton = ref<HTMLElement | null>(null);
    const cType = ref(props.type);
    const cValue = ref(props.value);
    const cEnum = ref(props.enum);
    const txtLoading = ref(props.textLoading);
    const cClass = ref(props.class);
    const loading = computed(() => {
      return props.isLoading;
    });
    const disabled = computed(() => {
      return props.isDisabled;
    });

    const className = (value: string) => {
      const c = value ? value.split(/\s+/) : "";

      return c ? `${c[0]} ${c[0]}-disabled` : c ? c : "";
    };

    const emitHandler = (event: MouseEvent) => {
      const btnElement = pippleButton.value;
      if (!btnElement) return;

      const btnConfig = btnElement.getBoundingClientRect();

      const x = event.clientX - btnConfig.left;
      const y = event.clientY - btnConfig.top;

      const pippleElement = document.createElement("div");
      pippleElement.className = "btn-pipple";
      pippleElement.style.top = `${y}px`;
      pippleElement.style.left = `${x}px`;
      btnElement.appendChild(pippleElement);

      setTimeout(() => {
        btnElement.removeChild(pippleElement);
      }, 700);
    };

    const handler = (event: MouseEvent) => {
      emitHandler(event);
      emit("handler", event);
    };

    return {
      className,
      emitHandler,
      handler,
      pippleButton,
      loading,
      disabled,
      cType,
      cValue,
      cEnum,
      txtLoading,
      cClass,
    };
  },
});
